import * as _ from 'underscore';
import React, { Component } from 'react';

import DesignerBase from './designer-base/DesignerBase';

import Console from '../../lib/debug';

import { getState } from '../../state/store';

import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as DesignerState from '../../state/reducer/designer/designer';
import * as ProgramTypes from '../../state/reducer/calendar/programTypes';

export default class CalendarDesignerView extends Component {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentDidUpdate() {
        this.loadCalendarData(this.props);
    }

    async loadCalendarData(props) {
        const programId = parseInt(props.match.params.programId);
        const year = parseInt(props.match.params.year);
        const month = parseInt(props.match.params.month);
        const day = parseInt(props.match.params.day);

        const dayKey = `${year}_${month}_${day}`;
        const isLoaded = _.values(getState().calendar.dayList).includes(dayKey);
        const infoTree = getState().calendar.infoTree;

        const programMatch =
            infoTree.programId === programId || infoTree.team.id === programId;

        DesignerState.setInfo(ProgramTypes.TYPES.CALENDAR, props.match.params);
        if (isLoaded && programMatch) return;

        CalendarState.loadCalendar(programId, year, month, day);
    }

    render() {
        Console.render('CalendarDesignerView');
        return <DesignerBase />;
    }
}
